import _ from "lodash";

function mergeResult(results) {
  let mergedObj = {};
  _.map(results, item => {
    _.map(item, ({ inputName, value: values }) => {
      _.map(values, value => {
        if (isNaN(value)) {
          return null;
        }
        if (!_.has(mergedObj[inputName], value)) {
          return (mergedObj = {
            ...mergedObj,
            [inputName]: {
              ...mergedObj[inputName],
              [value]: 1
            }
          });
        }
        mergedObj = {
          ...mergedObj,
          [inputName]: {
            ...mergedObj[inputName],
            [value]: mergedObj[inputName][value] + 1
          }
        };
      });
    });
  });
  return mergedObj;
}
export default mergeResult;



// WEBPACK FOOTER //
// ./src/components/Admin/surveys/Results/ResultsWithCharts/getMergedResults.js